var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBacktotop = function SvgBacktotop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 55 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "m27.5.707 19.199 19.199L27.5 53.004 8.301 19.906 27.5.707Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M35.936 21.98 29.07 14.83a2.033 2.033 0 0 0-2.95 0l-6.866 7.151"
  })));
};
export default SvgBacktotop;